export default __webpack_public_path__ + "static/media/4PLAYwheelbanner.e8507e33.gif";